<span class="ui-app-badge">
  <span class="ui-app-badge__dot"></span>
  {{ label }}
</span>
